/* eslint-disable max-lines */
export const APP = {
    SAVE_LOCATION: 'APP@SAVE_LOCATION',
    GET_ROUTER_INFO: 'APP@GET_ROUTER_INFO',
};

export const LOCATION_CHANGED = '@@router/LOCATION_CHANGE';

export const ROUTER = {
    GET_PAGE_INFO: 'ROUTER@GET_PAGE_INFO',
    SET: 'ROUTER@SET',
};

export const PRODUCT = {
    SET_PRODUCT: 'PRODUCT@SET_PRODUCT',
    GET_PRODUCT: 'PRODUCT@GET_PRODUCT',
    SET_ACTIVE_PRODUCT_ID: 'PRODUCT@SET_ID',
    CHECK_IS_PRODUCT_ID_IN_MY_FIT: 'PRODUCT@CHECK_IS_PRODUCT_ID_IN_MY_FIT',
    GET_QUOTE_ITEM: 'PRODUCT@GET_QUOTE_ITEM',
    GET_UPSELL: 'PRODUCT@GET_UPSELL',
    UPLOAD_REVIEW_FILE: 'PRODUCT@UPLOAD_REVIEW_FILE',
    SEND_REVIEW: 'SEND_REVIEW',
    RESET_QUOTE_ITEM: 'PRODUCT@RESET_QUOTE_ITEM',
    SET_READERS_POWER: 'PRODUCT@SET_READERS_POWER',
    SET_NO_READERS_POWER_ERROR: 'PRODUCT@SET_NO_READERS_POWER_ERROR',
    FILL_REVIEW_FORM: 'PRODUCT@FILL_REVIEW_FORM',
    FETCH_REVIEWS: 'PRODUCT@FETCH_REVIEWS',
    FETCH_REVIEWS_PHOTOS_LIST: 'PRODUCT@FETCH_REVIEWS_PHOTOS_LIST',
    CLEAR_REVIEWS: 'PRODUCT@CLEAR_REVIEWS',
    CLEAR_PRODUCT: 'PRODUCT@CLEAR_PRODUCT',
    CLEAR_SENDING_STATUS_REVIEW: 'PRODUCT@CLEAR_SENDING_STATUS_REVIEW',
    FETCH_BANNER: 'PRODUCT@FETCH_BANNER',
    GET_DISCOUNT_PRICE: 'PRODUCT@GET_DISCOUNT_PRICE',
    OPENED: 'PRODUCT@OPENED',
    RESET_ALL_STEPS: 'PRODUCT@RESET_ALL_STEPS',
    SET_COLLAPSE: 'COLLAPSES@SET_COLLAPSE',
    SEND_EEC_EVENT: 'PRODUCT@SEND_EEC_EVENT',
};

export const WIZARD = {
    GET_PRODUCT_WIZARD: 'WIZARD@GET_PRODUCT_WIZARD',
    // DEPRECATED
    SAVE_PRESCRIPTION_DATA: 'WIZARD@SAVE_PRESCRIPTION_DATA',
    SET_ACTIVE_PRODUCT_WIZARD_TAB: 'PW@SET_ACTIVE_PRODUCT_WIZARD_TAB',
    SET_PRESCRIPTION_ERROR: 'PW@SET_PRESCRIPTION_ERROR',
    PRESCRIPTION_FILLED: 'WIZARD@PRESCRIPTION_FILLED',
    SCROLL_TO: 'WIZARD@SCROLL_TO',
    FETCH: 'WIZARD@FETCH',
    FILLED: 'WIZARD@FILLED',
    RESET: 'WIZARD@RESET',
    /* TODO REMOVE THIS ACTION */
    SET_CUSTOMER_CONFIGURATION: 'WIZARD@SET_CUSTOMER_CONFIGURATION_DEPRECATED',
    SET_ACTIVE_STEP: 'WIZARD@SET_ACTIVE_STEP',
    TOGGLE_STICKY: 'WIZARD@TOGGLE_STICKY',
};

export const CUSTOMER_CONFIGURATION = {
    REMOVE_OPTION: 'CUSTOMER_CONFIGURATION@REMOVE_OPTION',
    SET_OPTION: 'CUSTOMER_CONFIGURATION@SET_OPTION',
    SET_PACKAGE: 'CUSTOMER_CONFIGURATION@SET_PACKAGE',
    SET_UPSELL: 'CUSTOMER_CONFIGURATION@SET_UPSELL',
    TOGGLE_ANTIFOG_OPTION: 'CUSTOMER_CONFIGURATION@TOGGLE_ANTIFOG_OPTION',
    SET_PRESCRIPTION_METHOD: 'CUSTOMER_CONFIGURATION@SET_PRESCRIPTION_METHOD',
    SET_PARAMETER: 'CUSTOMER_CONFIGURATION@SET_PARAMETER',
    SET_QUANTITY: 'CUSTOMER_CONFIGURATION@SET_QUANTITY',
    RESET_UPSELLS: 'CUSTOMER_CONFIGURATION@RESET_UPSELLS',
    RESET: 'CUSTOMER_CONFIGURATION@RESET',
};

export const GDL = {
    GLOBAL_DATA_LAYER_READY_TO_FILL: 'GDL@GLOBAL_DATA_LAYER_READY_TO_FILL',
    GLOBAL_DATA_LAYER_FULFILLED: 'GDL@GLOBAL_DATA_LAYER_FULFILLED',
};

export const COUPON = {
    ADD_COUPON: 'COUPON@ADD_COUPON',
    REMOVE_COUPON: 'COUPON@REMOVE_COUPON',
    REMOVE_COUPON_MESSAGE: 'COUPON@REMOVE_COUPON_MESSAGE',
};

export const MONTHLY_PAYMENTS = {
    GET_DATA: 'MONTHLY_PAYMENTS@GET_DATA',
};

export const CART = {
    GET_ITEMS: 'CART@GET_ITEMS',
    GET_PAYMENT_BUTTONS: 'CART@GET_PAYMENT_BUTTONS',
    CHANGE_ITEM_QTY: 'CART@CHANGE_ITEM_QTY',
    CHANGE_LENSES_ITEM_QTY: 'CART@CHANGE_LENSES_ITEM_QTY',
    REMOVE_QUOTE_ITEM: 'CART@REMOVE_QUOTE_ITEM',
    ADD_UPSELL_ITEM: 'CART@ADD_UPSELL_ITEM',
    REMOVE_UPSELL_ITEM: 'CART@REMOVE_UPSELL_ITEM',
    ADD_TO_CART: 'CART@ADD_TO_CART',
    UPDATE_CART: 'CART@UPDATE_CART',
    INIT_CART_SAGA: 'CART@INIT_CART_SAGA',
    GET_ITEMS_COUNT: 'CART@GET_ITEMS_COUNT',
    GET_POPUP_CONTENT: 'CART@GET_POPUP_CONTENT',
    CLEAR_CART_ADD: 'CART@CLEAR_CART_ADD',
    LAUNCH_ADDING_TO_CART: 'CART@LAUNCH_ADDING_TO_CART',
    CLEAR_STATUS_ITEM_V2: 'CART@CLEAR_STATUS_ITEM_V2',
    UPDATE_CART_ITEM_SUBSCRIPTION: 'UPDATE_CART_ITEM_SUBSCRIPTION',
};

export const BLOG = {
    GET_POSTS: 'BLOG@GET_POSTS',
    GET_ONE_POST: 'BLOG@GET_ONE_POST',
};

export const QUOTE_ITEM = {
    GET_ITEMS: 'GET_QUOTE_ITEMS',
};

export const CMS_BANNER = {
    START_SAGA_BANNER: 'CMS_BANNER@START_SAGA_BANNER',
    GET_POPUP: 'CMS_BANNER@GET_POPUP',
};

export const CATEGORY = {
    CHANGED_FILTER: 'CATEGORY@CHANGED_FILTER',
    GET_CATEGORY: 'CATEGORY@GET_CATEGORY',
    GET_CATEGORY_ITEMS: 'CATEGORY@GET_CATEGORY_ITEMS',
    GET_CATEGORY_ITEMS_COUNT: 'CATEGORY@GET_CATEGORY_ITEMS_COUNT',
    GET_FILTERS_CATEGORY: 'CATEGORY@GET_FILTERS_CATEGORY',
    SET_PAGE_NUMBER: 'CATEGORY@SET_PAGE_NUMBER',
    GET_ACTIVE_SORT: 'CATEGORY@GET_ACTIVE_SORT',
    GET_STATE_FILTER: 'CATEGORY@GET_STATE_FILTER',
    GET_APPLY_FILTER: 'CATEGORY@GET_APPLY_FILTER',
    GET_STATE_SORT: 'CATEGORY@GET_STATE_SORT',
    SET_ACTIVE_FILTERS: 'CATEGORY@SET_ACTIVE_FILTERS',
    REMOVE_ACTIVE_FILTERS: 'CATEGORY@REMOVE_ACTIVE_FILTERS',
    SEND_ANALYTICS_FILTER: 'CATEGORY@SEND_ANALYTICS_FILTER',
    CLEAR_CATEGORY_DATA: 'CATEGORY@CLEAR_CATEGORY_DATA',
    SET_EYE_WEAR_FILTER: 'CATEGORY@SET_EYE_WEAR_FILTER',
};

export const NEWSLETTER = {
    SUBSCRIBE: 'NEWSLETTER@SUBSCRIBE',
};

export const CUSTOMER = {
    SEND_REGISTRATION: 'CUSTOMER@SEND_REGISTRATION',
    GET_CUSTOMER_DATA: 'CUSTOMER@GET_CUSTOMER_DATA',
    FETCH_PRESCRIPTION: 'CUSTOMER@FETCH_PRESCRIPTION',
};

export const PRESCRIPTION = {
    FETCH: 'PRESCRIPTION@FETCH',
    SET_PRESCRIPTION: 'PRESCRIPTION@SET_PRESCRIPTION',
    SET_ERRORS: 'PRESCRIPTION@SET_ERRORS',
    VALIDATE: 'PRESCRIPTION@VALIDATE',
};

export const ANALYTICS = {
    EEC_PRODUCT_CLICK: 'ANALYTICS@EEC_PRODUCT_CLICK',
    CATEGORY_COLOR_CHANGE: 'ANALYTICS@CATEGORY_COLOR_CHANGE',
    PDP_ATTR_CHANGE: 'ANALYTICS@PDP_ATTR_CHANGE',
    DY_CHANGE_ATTRIBUTE: 'ANALYTICS@DY_CHANGE_ATTRIBUTE',
    KEYWORD_SEARCH: 'ANALYTICS@KEYWORD_SEARCH',
};

export const GENDER = {
    SET: 'GENDER@SET',
};

export const PROFILE = {
    GET_ORDERS: 'PROFILE@GET_ORDERS',
    GET_CUSTOMER_REVIEW: 'PROFILE@GET_CUSTOMER_REVIEW',
    GET_CUSTOMER_ORDER: 'PROFILE@GET_CUSTOMER_ORDER',
    GET_REGION_LIST: 'PROFILE@GET_REGION_LIST',
    GET_CUSTOMER_ADDRESS_BY_ID: 'PROFILE@GET_CUSTOMER_ADDRESS_BY_ID',
    GET_CUSTOMER_ADDRESS: 'PROFILE@GET_CUSTOMER_ADDRESS',
    SET_CUSTOMER_FORM: 'PROFILE@SET_CUSTOMER_FORM',
    GET_CMS_BLOCK_BY_ID: 'PROFILE@GET_CMS_BLOCK_BY_ID',
    GET_EMAIL_BY_TOKEN: 'PROFILE@GET_EMAIL_BY_TOKEN',
    SET_VALIDATION_ADDRESS_NEW: 'PROFILE@SET_VALIDATION_ADDRESS_NEW',
    SET_VALIDATION_ACCOUNT_EDIT: 'PROFILE@SET_VALIDATION_ACCOUNT_EDIT',
    SET_DEFAULT_SHIPPING_ADDRESS: 'PROFILE@SET_DEFAULT_SHIPPING_ADDRESS',
    SET_DEFAULT_BILLING_ADDRESS: 'PROFILE@SET_DEFAULT_BILLING_ADDRESS',
    SET_CUSTOMER_SUBSCRIBED: 'PROFILE@SET_CUSTOMER_SUBSCRIBED',
    SET_ADDITIONAL_ADDRESSES: 'PROFILE@SET_ADDITIONAL_ADDRESSES',
    SAVE_ADDRESS: 'PROFILE@SAVE_ADDRESS',
    SAVE_SUBSCRIBED: 'PROFILE@SAVE_SUBSCRIBED',
    SAVE_ACCOUNT_EDIT: 'PROFILE@SAVE_ACCOUNT_EDIT',
    SAVE_ADDRESS_EDIT: 'PROFILE@SAVE_ADDRESS_EDIT',
    CLEAR_ADDRESS_NEW: 'PROFILE@CLEAR_ADDRESS_NEW',
    NOTIFICATION: 'PROFILE@NOTIFICATION',
    SAVE_ACCOUNT_INFORMATION: 'PROFILE@SAVE_ACCOUNT_INFORMATION',
    SAVE_SUBSCRIPTION_SETTINGS: 'PROFILE@SAVE_SUBSCRIPTION_SETTINGS',
    REMOVE_CUSTOMER_ADDRESS: 'PROFILE@REMOVE_CUSTOMER_ADDRESS',
};

export const SEARCH_RESULTS = {
    START_GET_SEARCH_RESULTS_SAGA: 'SEARCH_RESULTS@START_GET_SEARCH_RESULTS_SAGA',
    GET_SEARCH_RESULTS: 'SEARCH_RESULTS@GET_SEARCH_RESULTS',
};

export const CONTACTS = {
    START_SEND_USERS_DATA_SAGA: 'CONTACTS@START_SEND_USERS_DATA_SAGA',
    SEND_USERS_DATA: 'CONTACTS@SEND_USERS_DATA',
    SET_NOTIFICATION: 'CONTACTS@SET_NOTIFICATION',
    SET_GRATITUDE: 'CONTACTS@SET_GRATITUDE',
};

export const BRONTO = {
    EMAIL_CAPTURE: 'BRONTO@EMAIL_CAPTURE',
    SUBSCRIBE: 'BRONTO@SUBSCRIBE',
};

export const MYPICKS = {
    TOGGLE: 'MYPICKS@TOGGLE',
};

export const ORDER = {
    SAVE_ORDER: 'SAVE_ORDER',
};

export const CHECKOUT = {
    CHOOSE_PAYMENT_METHOD: 'CHECKOUT@CHOOSE_PAYMENT_METHOD',
    SET_PAYMENT_METHOD_TOKEN: 'CHECKOUT@SET_PAYMENT_METHOD_TOKEN',
    SET_PAYMENT_ERROR: 'CHECKOUT@SET_PAYMENT_ERROR',
    SET_ACTIVE_PAYMENT: 'CHECKOUT@SET_ACTIVE_PAYMENT',
    SUBMIT_PAYMENT_METHOD: 'CHECKOUT@SUBMIT_PAYMENT_METHOD',
    PAY_WITH_SAVED_CARD: 'CHECKOUT@PAY_WITH_SAVED_CARD',
    SUBMIT_INSTANT_PAYMENT_METHOD: 'CHECKOUT@SUBMIT_INSTANT_PAYMENT_METHOD',
    PAY_WITH_NEW_CARD: 'CHECKOUT@PAY_WITH_NEW_CARD',
    UPDATE_BILLING_ADDRESS: 'CHECKOUT@UPDATE_BILLING_ADDRESS',
    SAVE_CARD: 'CHECKOUT@SAVE_CARD',
    SET_IN_PROGRESS: 'CHECKOUT@SET_IN_PROGRESS',
    REMOVE_INVALID_CARD: 'CHECKOUT@REMOVE_INVALID_CARD',
    SAVE_ORDER: 'CHECKOUT@SAVE_ORDER',
    SAVE_ORDER_SUCCESS: 'CHECKOUT@SAVE_ORDER_SUCCESS',
    SET_SAVE_ORDER_ERROR: 'CHECKOUT@SET_SAVE_ORDER_ERROR',
    PLACE_ORDER: 'CHECKOUT@PLACE_ORDER',
    SAVE_SHIPPING_METHOD: 'CHECKOUT@SAVE_SHIPPING_METHOD',
    SET_SHIPPING_METHOD_ERROR: 'CHECKOUT@SET_SHIPPING_METHOD_ERROR',
    GET_SHIPPING_METHODS: 'CHECKOUT@GET_SHIPPING_METHODS',
    SET_SHIPPING_METHODS: 'CHECKOUT@SET_SHIPPING_METHODS',
    GET_ORDER_REVIEW_ITEMS: 'CHECKOUT@GET_ORDER_REVIEW_ITEMS',
    SET_APPLEPAY_AND_SUBMIT: 'CHECKOUT@SET_APPLEPAY_AND_SUBMIT',
    SHOW_PREPAID_MESSAGE: 'CHECKOUT@SHOW_PREPAID_MESSAGE',
    RESET_ORDER_ERRORS: 'CHECKOUT@RESET_ORDER_ERRORS',
    SET_SUBSCRIBTION_CHECKBOX_STATUS: 'CHECKOUT@SET_SUBSCRIBTION_CHECKBOX_STATUS',
};

export const MENU = {
    SET_VISIBILITY_MENU: 'MENU@SET_VISIBILITY_MENU',
};

export const WISHLIST = {
    SET_WISHLIST_ITEMS: 'SET_WISHLIST_ITEMS',
};
